import { render } from "./register.vue?vue&type=template&id=63a91ab8"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__